/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="speak" size=32 />
 */
const Speak = () => (
	<>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.2533 23.6916C20.3496 23.4927 20.5888 23.4097 20.7876 23.506L24.743 25.4226C24.9418 25.5189 25.0249 25.7581 24.9286 25.9569C24.8322 26.1557 24.593 26.2388 24.3942 26.1425L20.4388 24.2259C20.24 24.1296 20.1569 23.8904 20.2533 23.6916Z"
			fill="#B9DEFA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.6126 25.643C16.8252 25.583 17.0462 25.7067 17.1062 25.9193L18.2271 29.8913C18.2871 30.104 18.1634 30.3249 17.9508 30.3849C17.7382 30.4449 17.5172 30.3212 17.4572 30.1086L16.3363 26.1366C16.2763 25.924 16.4 25.703 16.6126 25.643Z"
			fill="#B9DEFA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.5336 18.4798C25.5936 18.6924 25.4699 18.9134 25.2573 18.9734L20.7854 20.2354C20.5727 20.2954 20.3517 20.1717 20.2917 19.9591C20.2317 19.7464 20.3555 19.5255 20.5681 19.4655L25.04 18.2034C25.2526 18.1434 25.4736 18.2671 25.5336 18.4798Z"
			fill="#B9DEFA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.8801 15.3407L13.2829 2.15631L14.0193 1.84369L20.0888 16.1407H14.0511V20.3694L7.48446 16.4699C7.59966 17.4633 7.95226 18.7175 8.69646 19.8493C9.62833 21.2666 11.1798 22.5037 13.6983 22.8028L14.1483 22.8562L12.4838 29.5776L11.7073 29.3853L13.1564 23.5336C10.6429 23.1158 9.0217 21.8001 8.02801 20.2888C6.98652 18.7048 6.64001 16.9176 6.64001 15.7407V15.038L13.2511 18.9639V15.3407H18.8801Z"
			fill="#002D55"
		/>
		<path
			d="M10.1512 10.8148C10.7239 10.8148 11.1882 10.3505 11.1882 9.77776C11.1882 9.20502 10.7239 8.74072 10.1512 8.74072C9.57843 8.74072 9.11414 9.20502 9.11414 9.77776C9.11414 10.3505 9.57843 10.8148 10.1512 10.8148Z"
			fill="#002D55"
		/>
	</>
);

export default Speak;
